// How long to consider it the new year before the next year countdown begins
const NEW_YEAR_PERIOD_MS = 24 * 60 * 60 * 1000;
const TIMER_END_FIRE_GRACE_MS = 4 * 1000;

export default class CountdownTimer {

    constructor(options) {
        this.options = options;
        this.dispDiv = document.getElementById(options.displayDivId);
        this.timeOffset = 0.0; // difference between client and server time
        this.finishMsg = 'Happy New Year!';
        this.timerEndMillies = this.getNewYearTime(); // time we're counting down to
        this.adjustTimeToServer();
    }

    update() {
        
        const timeLeft = this.getTimeLeft();
        if (timeLeft <= 0.0) {
            // Call the timer end func if the timer crossed the target with 4 sec grace period
            if (this.options.onTimerEnd && timeLeft >= - TIMER_END_FIRE_GRACE_MS) {
                this.options.onTimerEnd();
                this.options.onTimerEnd = null;
            }
            // Do nothing on future updates since the text won't be changed
            this.update = () => { return 0; }
        }

        const timeLeftStr = this.getTimeDiffStr(timeLeft);

        // Only update the DOM on changes
        if (timeLeftStr !== this.prevTimeLeftStr) {
            while (this.dispDiv.hasChildNodes()) {
                this.dispDiv.removeChild(this.dispDiv.firstChild);
            }
            this.dispDiv.appendChild(document.createTextNode(timeLeftStr));
            this.prevTimeLeftStr = timeLeftStr;
        }
        return timeLeft;
    }

    adjustTimeToServer() {
        this.timeOffset = 0;
        const ajaxReqTime = new Date().getTime();
        const processServerTime = (content) => {
            const serverTime = parseFloat(content);
            if (!isNaN(serverTime)) {
                const ajaxReqFinishTime = new Date().getTime();
                const avgJSTime = ajaxReqTime + ((ajaxReqFinishTime - ajaxReqTime) / 2);
                const svrTime = serverTime * 1000;
                this.timeOffset = avgJSTime - svrTime;
            }
        }
        const http = new XMLHttpRequest();
        http.open('GET', '/currenttime', true);
        http.onreadystatechange = function () {
            if (http.readyState == 4 && http.status >= 200 && http.status < 300) {
                processServerTime(http.responseText);
            }
        }
        http.send(null);
    }

    jumpTimerSecLeft(sec) {
        this.timeOffset = new Date().getTime() - this.getNewYearTime()
            + (1000.0 * sec);
    }

    getTimeLeft() {
        const milliesNow = new Date().getTime();
        return this.timerEndMillies - milliesNow + this.timeOffset;
    }

    getNewYearTime() {
        // We want to display 'Happy New Year' all new years day, so
        // get the msec from one day prior
        const tMillies = (new Date().getTime()) - NEW_YEAR_PERIOD_MS;
        // Then use that to get the target year value
        const endYear = (new Date(tMillies).getUTCFullYear()) + 1;
        return Date.UTC(endYear, 0, 1);
    }

    getTimerYear() {
        return new Date(this.getNewYearTime()).getUTCFullYear();
    }

    getTimeDiffStr(milliesLeft) {
        if (milliesLeft <= 0) {
            return this.finishMsg;
        }
        const vals = [ 0, 0, 0, 0 ];
        const units = [ 'days', 'hours', 'minutes', 'seconds'];

        // Days
        vals[0] = Math.floor(milliesLeft / 1000 / 60 / 60 / 24);
        let diff = milliesLeft - vals[0] * 1000 * 60 * 60 * 24;

        // Hours
        vals[1] = Math.floor(diff / 1000 / 60 / 60);
        diff -= vals[1] * 1000 * 60 * 60;

        // Minutes
        vals[2] = Math.floor(diff / 1000 / 60);
        diff -= vals[2] * 1000 * 60;

        // Seconds. Show 1 decimal place in the final second
        const dp = 1 - Math.min(Math.floor(milliesLeft/1000), 1);
        vals[3] = new Number(Math.floor(diff / 1000));
        diff -= vals[3] * 1000;

        // Deciseconds if < 1.0
        vals[3] += (diff / 1000).toFixed(dp).substring(1);

        // Eliminate the first few time units if they start with 0
        let i = 0;
        while(vals[i] == 0 && i < vals.length - 1) {
            i++;
        }

        // concat the string values we want to show
        let diffStr = '';
        for (; i < vals.length; i++) {
            diffStr += vals[i] + ' ' + units[i] + ' ';
        }

        return diffStr;
    }
}
